module.exports = __webpack_public_path__ + "assets/img/gjzq.82401114.png";